import { API_ADMIN } from 'src/lib/api'

export async function getEmpresas(token, params) {
  const response = await API_ADMIN.get(`/MinhasEmpresas`, { token: token })

  if (response.ok) {
    return response.data
  }

  throw response.originalError
}

export async function getMultiEmpresas(token, params) {
  const response = await API_ADMIN.get(`/MinhasEmpresas/MultiEmpresa`, { ...params, token })

  if (response.ok) {
    return response.data
  }

  throw response.originalError
}

export async function setEmpresa(token, idEmpresa) {
  const payload = {
    idEmpresa,
  }

  const response = await API_ADMIN.post(`/MinhasEmpresas`, payload, { token })

  if (response.ok) {
    return response.data
  }

  throw response.originalError
}
